// Frontend-only MOCK data + localStorage persistence.
// This will be replaced with real API calls when backend is connected.

const LS_KEYS = {
  updates: "cellza_updates_v1",
  conversations: "cellza_conversations_v1",
};

const safeParse = (raw, fallback) => {
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const mockContent = {
  nav: [
    { label: "Home", to: "/" },
    { label: "Focus Areas", to: "/focus-areas" },
    { label: "Collaborate", to: "/collaborate" },
  ],
  interestAreas: [
    { value: "investor", label: "Investor" },
    { value: "partner", label: "Partner" },
    { value: "talent", label: "Talent" },
    { value: "other", label: "Other" },
  ],
  privacy: {
    title: "Privacy",
    body: [
      "Cellza is in early strategic development. We keep outreach minimal and intentional.",
      "If you choose to contact us, your message is treated confidentially and reviewed deliberately.",
      "This MVP stores submissions locally in your browser only (MOCKED). When backend is connected, this will be replaced with secure server-side handling.",
    ],
  },
};

export const mockStorage = {
  getUpdates() {
    if (typeof window === "undefined") return [];
    return safeParse(window.localStorage.getItem(LS_KEYS.updates) || "[]", []);
  },
  addUpdate({ email }) {
    const prev = this.getUpdates();
    const next = [
      {
        id: crypto?.randomUUID?.() || `${Date.now()}_${Math.random()}`,
        email,
        createdAt: new Date().toISOString(),
      },
      ...prev,
    ].slice(0, 25);
    window.localStorage.setItem(LS_KEYS.updates, JSON.stringify(next));
    return next[0];
  },

  getConversations() {
    if (typeof window === "undefined") return [];
    return safeParse(
      window.localStorage.getItem(LS_KEYS.conversations) || "[]",
      [],
    );
  },
  addConversation(payload) {
    const prev = this.getConversations();
    const next = [
      {
        id: crypto?.randomUUID?.() || `${Date.now()}_${Math.random()}`,
        ...payload,
        createdAt: new Date().toISOString(),
      },
      ...prev,
    ].slice(0, 50);
    window.localStorage.setItem(LS_KEYS.conversations, JSON.stringify(next));
    return next[0];
  },
};
